import React from 'react';
const CancellationPolicyPage = () => {
  return <div data-id="element-216">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-217">
        <div className="container mx-auto px-4" data-id="element-218">
          <div className="max-w-3xl mx-auto text-center" data-id="element-219">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-220">
              Cancellation Policy
            </h1>
            <p className="text-lg text-gray-200" data-id="element-221">
              Information about our cancellation terms and procedures
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-222">
        <div className="container mx-auto px-4" data-id="element-223">
          <div className="max-w-3xl mx-auto" data-id="element-224">
            <div className="prose prose-lg max-w-none" data-id="element-225">
              <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-226">
                Cancellation Policy & Exclusions
              </h2>
              <p className="mb-6" data-id="element-227">
                At PinnacleHub, your satisfaction with our service plans is our
                priority. We understand that circumstances can change, so we
                offer a simple and transparent cancellation process to give you
                peace of mind.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-228">
                Cancellation Within 14 Days
              </h3>
              <p className="mb-6" data-id="element-229">
                You have the right to cancel your service plan within 14 days of
                purchase. If you cancel within this period, you'll receive a
                full refund—no questions asked. This cooling-off period lets you
                review your plan to ensure it meets your needs.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-230">
                Cancellation After 14 Days and Within 28 Days
              </h3>
              <p className="mb-6" data-id="element-231">
                If you decide to cancel after the initial 14-day period but
                within 28 days from purchase, you may be eligible for a partial
                refund. This refund is granted at PinnacleHub's discretion,
                considering any services or repairs already provided under your
                plan.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-232">
                No Cancellations or Refunds After 28 Days
              </h3>
              <p className="mb-6" data-id="element-233">
                Cancellations and refunds cannot be processed after 28 days from
                the purchase date. Please review your plan carefully and contact
                us promptly if you have any concerns or need assistance.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-234">
                How to Cancel Your Service Plan
              </h3>
              <p className="mb-6" data-id="element-235">
                To cancel your plan, please contact our customer support team
                using the following:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-236">
                <li className="mb-2" data-id="element-237">Phone: 0800 055 4969</li>
                <li className="mb-2" data-id="element-238">Email: Bikashbuddha2004@gmail.com</li>
              </ul>
              <p className="mb-6" data-id="element-239">
                Once we receive your cancellation request, we'll review your
                case promptly. If eligible, your refund will be processed
                quickly, and you'll receive confirmation when your cancellation
                and refund are complete.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-240">
                Refund Processing
              </h3>
              <p className="mb-6" data-id="element-241">
                All refunds are made to the original payment method used at
                purchase. For security reasons, we don't process refunds to
                alternative accounts or payment methods.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-242">
                Plan Exclusions and Coverage Limits
              </h3>
              <p className="mb-6" data-id="element-243">
                To maintain fairness and service quality, the following are
                excluded from coverage under your PinnacleHub plan:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-244">
                <li className="mb-2" data-id="element-245">
                  <strong data-id="element-246">Pre-existing Faults:</strong> Faults or damage present
                  before your plan started are not covered.
                </li>
                <li className="mb-2" data-id="element-247">
                  <strong data-id="element-248">Misuse or Neglect:</strong> Damage caused by improper
                  use, neglect, accidents, or unauthorized repairs is excluded.
                </li>
                <li className="mb-2" data-id="element-249">
                  <strong data-id="element-250">Non-standard Repairs:</strong> Repairs beyond normal
                  appliance operation or servicing, including modifications or
                  alterations, are excluded.
                </li>
                <li className="mb-2" data-id="element-251">
                  <strong data-id="element-252">Illegal or Fraudulent Use:</strong> Any fraudulent or
                  illegal use of our services will result in immediate plan
                  cancellation without refund.
                </li>
                <li className="mb-2" data-id="element-253">
                  <strong data-id="element-254">Manufacturer's Guidelines:</strong> Appliances not
                  used or maintained as per manufacturer instructions are
                  excluded.
                </li>
              </ul>
              <p className="mb-6" data-id="element-255">
                If any of these exclusions apply, your plan may be voided
                immediately, and you'll lose eligibility for repairs or refunds
                under the plan.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-256">
                Need Help?
              </h3>
              <p className="mb-6" data-id="element-257">
                If you have any questions about cancelling your plan or want
                clarification on coverage, please contact our customer service
                team. We're here to support you and ensure you understand your
                options clearly.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default CancellationPolicyPage;